import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Cookies } from "react-cookie";
import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";

export const dashboardActivities = createAsyncThunk(
  "dashboardActivities",
  async (id) => {
    try {
      const cookies = new Cookies();
      const token = cookies.get("token");
      const response = await AxiosInstance.get(
        `${API_KEY}/api/activity/all`,

        {
          headers: {
            Authorization: `Barear ${token}`,
          },
          "Content-Type": "application/json",
        }
      );

      return response;
    } catch (error) {
      if (error.response) {
        throw error.response.data.message;
      } else {
        throw error;
      }
    }
  }
);

const initialState = {
  isLoading: false,
  dashboardActivitiesData: null,
  isError: false,
  errorMessage: "",
};
const dashboardActivitiesSlice = createSlice({
  name: "dashboardActivities",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(dashboardActivities.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(dashboardActivities.fulfilled, (state, action) => {
      state.isLoading = false;
      state.dashboardActivitiesData = action.payload;
    });
    builder.addCase(dashboardActivities.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default dashboardActivitiesSlice.reducer;
